import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { signupExperimentProperties } from './model';

type SignupPayload = Parameters<typeof MixpanelEvents.signUp>[0];

export const SignupExperimentEvents = {
  emailSignUpProceedClick: (properties?: SignupPayload) =>
    MixpanelEvents.emailSignUpProceedClick({ ...signupExperimentProperties(), ...properties }),
  signUp: (properties?: SignupPayload) =>
    MixpanelEvents.signUp({ ...signupExperimentProperties(), ...properties }),
  signUpPageShown: (properties?: SignupPayload) =>
    MixpanelEvents.signUpPageShown({ ...signupExperimentProperties(), ...properties }),
  signUpWithGoogleClick: (properties?: SignupPayload) =>
    MixpanelEvents.signUpWithGoogleClick({ ...signupExperimentProperties(), ...properties }),
  signUpWithSSOClick: (properties?: SignupPayload) =>
    MixpanelEvents.signUpWithSSOClick({ ...signupExperimentProperties(), ...properties }),
};
